import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function CTASection() {
  return <section className="py-20 md:py-32 bg-blue-600 relative overflow-hidden" data-id="element-1">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-2" />

      <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-3">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-4">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8" data-id="element-5">
            Book Your Free AI Hiring Consultation
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12 text-blue-100" data-id="element-6">
            <div className="bg-blue-700/50 p-4 rounded-lg backdrop-blur-sm" data-id="element-7">
              Review your current hiring process
            </div>
            <div className="bg-blue-700/50 p-4 rounded-lg backdrop-blur-sm" data-id="element-8">
              Identify where AI saves time & money
            </div>
            <div className="bg-blue-700/50 p-4 rounded-lg backdrop-blur-sm" data-id="element-9">
              Outline a clear AI hiring roadmap
            </div>
          </div>

          <motion.a href="https://meetings.hubspot.com/mike745/consulting-meet-for-small-businesses" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.2)'
        }} whileTap={{
          scale: 0.98
        }} className="bg-amber-500 hover:bg-amber-400 text-white text-xl font-bold py-5 px-10 rounded-lg shadow-xl transition-all flex items-center gap-3 mx-auto inline-flex" data-id="element-10">
            Book Free Consultation <ArrowRight className="w-6 h-6" data-id="element-11" />
          </motion.a>

          <p className="mt-6 text-blue-200 font-medium" data-id="element-12">
            No sales pressure. No technical prep required.
          </p>
        </motion.div>
      </div>
    </section>;
}